  (function () {
    if (window.__imageTextSideBySideHasFired) {
      return;
    }

    window.Branch = window.Branch || {};
    window.Branch.imageTextSideBySide = window.Branch.imageTextSideBySide || {};
    window.__imageTextSideBySideHasFired = true;

    function savingsChart() {
        var savingsChartElement = document.getElementById('savings-chart');
        if(savingsChartElement){
            function drawSavingsChart(){
                $("#bars li .bar").each( function( key, bar ) {
                var percentage = $(this).data('percentage');

                $(this).animate({
                    'height' : percentage + '%'
                }, 1000);
                });
            }

            drawSavingsChart();
        }
    }

    function actionsOnVisible(uninitializedImageTextSideBySideSection){
        uninitializedImageTextSideBySideSection.setAttribute('data-interacted', true);
        window.Branch.nav.handleUpdateSrcSet(null, '.image-text-side-by-side__image', '.image-text-side-by-side__flex-item[data-type="image"]', 1280);     
        savingsChart();
    }

    function initImageTextSideBySideCallback(uninitializedImageTextSideBySideSection, parent, type){
        let fromLoad = uninitializedImageTextSideBySideSection.closest('.homepage-content-container') && uninitializedImageTextSideBySideSection.closest('.homepage-content-container').getAttribute('data-origin') == 'load';

        if(type == 'from-copy' && fromLoad == false){
            actionsOnVisible(uninitializedImageTextSideBySideSection);
        } else if(!uninitializedImageTextSideBySideSection.closest('.homepage-content-container')) {
            actionsOnVisible(uninitializedImageTextSideBySideSection);
        } else {
            const scrollHandler = function () {
            const containerRect = {top: 0, left: 0, bottom: window.innerHeight, right: window.innerWidth, width: window.innerWidth, height: window.innerHeight};
            const targetRect = uninitializedImageTextSideBySideSection.getBoundingClientRect();

            const isVisible =
                targetRect.bottom > containerRect.top &&
                targetRect.top < containerRect.bottom;

            if (
                isVisible &&
                uninitializedImageTextSideBySideSection.getAttribute("data-interacted") !== "true"
            ) {
                actionsOnVisible(uninitializedImageTextSideBySideSection, parent);
                uninitializedImageTextSideBySideSection.setAttribute("data-interacted", "true");
                window.removeEventListener("scroll", scrollHandler);
            }
        };

        window.addEventListener("scroll", scrollHandler);
        }
    }

    // Where the five parts of a review live, so the BYO quiz can swap in the one belonging to the product it recommended. Only instances with data-has-rating="true" are touched.
    var REVIEW_PARTS = {
        productName: '.image-text-side-by-side__subtitle',
        // Either element, whichever the section rendered; document order puts the heading first.
        quote: '.image-text-side-by-side__heading, .image-text-side-by-side__text',
        name: '.image-text-side-by-side__rating-text',
        title: '.image-text-side-by-side__rating-description'
    };

    var reviewOriginals = null;

    function reviewSections(){
        var columns = document.querySelectorAll('[data-has-rating="true"]');
        var sections = [];
        columns.forEach(function(column){
            // The image is in the section's other flex item, so the whole section is scope.
            var section = column.closest('.shopify-section') || column;
            if(sections.indexOf(section) === -1) sections.push(section);
        });
        return sections;
    }

    /* Remembered once, before the first write, so reset restores the theme's own copy. */
    function rememberReview(sections){
        if(reviewOriginals) return;
        reviewOriginals = [];

        sections.forEach(function(section){
            var original = { section: section, text: {}, image: null, stars: null };

            Object.keys(REVIEW_PARTS).forEach(function(field){
                var element = section.querySelector(REVIEW_PARTS[field]);
                if(element) original.text[field] = element.textContent;
            });

            var image = section.querySelector('.image-text-side-by-side__image');
            if(image) original.image = { src: image.getAttribute('src'), srcset: image.getAttribute('srcset') };

            var stars = section.querySelector('.image-text-side-by-side__rating-stars');
            if(stars) original.stars = { text: (stars.querySelector('span') || stars).textContent, label: stars.getAttribute('aria-label') };

            reviewOriginals.push(original);
        });
    }

    window.Branch.imageTextSideBySide.setReview = function(review){
        var sections = reviewSections();
        if(sections.length === 0) return false;
        rememberReview(sections);

        if(!review){
            window.Branch.imageTextSideBySide.resetReview();
            return true;
        }

        sections.forEach(function(section){
            Object.keys(REVIEW_PARTS).forEach(function(field){
                var element = section.querySelector(REVIEW_PARTS[field]);
                if(element && review[field]) element.textContent = review[field];
            });

            var stars = section.querySelector('.image-text-side-by-side__rating-stars');
            if(stars && review.rating){
                (stars.querySelector('span') || stars).textContent = '★★★★★'.slice(0, review.rating);
                stars.setAttribute('aria-label', review.rating + ' out of 5');
            }

            var image = section.querySelector('.image-text-side-by-side__image');
            if(image && review.image){
                /* srcset is REMOVED: left alone, the browser would pick from it and ignore the new src. */
                image.setAttribute('src', review.image);
                image.removeAttribute('srcset');
            }
        });

        return true;
    };

    /* Back to the theme's own review, so a swap never leaves the last product's quote behind. */
    window.Branch.imageTextSideBySide.resetReview = function(){
        if(!reviewOriginals) return;

        reviewOriginals.forEach(function(original){
            Object.keys(original.text).forEach(function(field){
                var element = original.section.querySelector(REVIEW_PARTS[field]);
                if(element) element.textContent = original.text[field];
            });

            if(original.stars){
                var stars = original.section.querySelector('.image-text-side-by-side__rating-stars');
                if(stars){
                    (stars.querySelector('span') || stars).textContent = original.stars.text;
                    if(original.stars.label === null) stars.removeAttribute('aria-label');
                    else stars.setAttribute('aria-label', original.stars.label);
                }
            }

            if(original.image){
                var image = original.section.querySelector('.image-text-side-by-side__image');
                if(image){
                    if(original.image.src === null) image.removeAttribute('src');
                    else image.setAttribute('src', original.image.src);
                    if(original.image.srcset === null) image.removeAttribute('srcset');
                    else image.setAttribute('srcset', original.image.srcset);
                }
            }
        });
    };

    window.Branch.imageTextSideBySide.initImageTextSideBySide = function(type){
        let uninitializedimageTextSideBySide = document.querySelectorAll('.shopify-section.feature-box:not([data-initialized="true"])');
        uninitializedimageTextSideBySide.forEach((uninitializedImageTextSideBySideSection) => {
            let parent = uninitializedImageTextSideBySideSection.closest('.shopify-section');
            uninitializedImageTextSideBySideSection.setAttribute('data-initialized', true);
            if(type == 'from-copy'){
                initImageTextSideBySideCallback(uninitializedImageTextSideBySideSection, parent, type)
            } else {
                window.Branch.functions.fireOnUserInteraction(initImageTextSideBySideCallback,  '.homepage-content-container', uninitializedImageTextSideBySideSection, uninitializedImageTextSideBySideSection, parent);
            }
        })
    }

    if (document.readyState === "complete") {
        window.Branch.imageTextSideBySide.initImageTextSideBySide('regular'); 
    } else {
        window.addEventListener("load", () => window.Branch.imageTextSideBySide.initImageTextSideBySide('regular'));
    }
  })();
